import React, { useEffect, useRef, useState } from "react";
import EditorJS from "@editorjs/editorjs";
import Header from "@editorjs/header";
import ImageTool from "@editorjs/image";
import List  from '@editorjs/list';
//import createGenericInlineTool, { UnderlineInlineTool } from 'editorjs-inline-tool'
import Table from "editorjs-table"
import RawTool from "@editorjs/raw"
import CodeTool from "@editorjs/code"
import { tooltipUploadImageFile } from "./CommonApi";

const EditorComponent = ({setContent,content,isPopup,event_id}) => {
    const [isEditorVisible, setIsEditiorVisible] = useState(true);
    const [editorInstance, setEditorInstance] = useState(null);
    const eventIdRef = useRef(event_id);

    useEffect(() => {
        eventIdRef.current = event_id;
    }, [event_id]);

    useEffect(() => {
        if(content && isEditorVisible){
            const editor = new EditorJS({
                holder : 'editor-container',
                tools : {
                    code: CodeTool,
                    raw: RawTool,
                    image : {
                        class  : ImageTool,
                        config : {
                            field: "image",
                            uploader : {
                                uploadByFile: async(file) => {
                                    const formData = new FormData(); 
                                    formData.append('upload_file', file);
                                    formData.append('event_id', event_id);
                                    let result = await tooltipUploadImageFile(formData);
                                    if(result.url){
                                        return  {
                                            "success" : 1,
                                            "file": {
                                                "url" : result.url,
                                                "blobPath" : result.blobPath,
                                            }
                                        };
                                    } else {
                                        return {
                                            "success" : 1,
                                            "file": {
                                                "url" : result.url,
                                                "blobPath" : result.blobPath,
                                            }
                                        };
                                    }
                                },
                                uploadByUrl : async(file) => {
                                    console.log('file url',file)
                                }
                            }
                        } 
                    },
                    table: {
                        class: Table,
                        inlineToolbar: true,
                        config: {
                            rows: 2,
                            cols: 3,
                        },
                    },
                    header: {
                        class: Header,
                    },
                    
                    list: {
                        class: List,
                        inlineToolbar: true,
                        config: {
                            defaultStyle: 'unordered'
                        }
                    }
                },
                data : content ,
                onChange: async (data) => {
                    setContent(await editor.save());
                },
                autofocus: true
            });
            setEditorInstance(editor);
            return () => {
                setIsEditiorVisible(false);
                if(editorInstance){
                    editorInstance.destroy();
                }
            };
        }
        // eslint-disable-next-line
    } ,[content,event_id,setContent]); 

    useEffect(() => {
        if(isPopup){
            const editor = new EditorJS({
                holder : 'editor-container',
                tools : {
                    code: CodeTool,
                    raw: RawTool,
                    image : {
                        class  : ImageTool,
                        config : {
                            uploader : {
                                uploadByFile: async(file) => {
                                    const formData = new FormData(); 
                                    formData.append('upload_file', file);
                                    formData.append('event_id', eventIdRef.current);
                                    let result = await tooltipUploadImageFile(formData);
                                    if(result.url){
                                        return  {
                                            "success" : 1,
                                            "file": {
                                                "url" : result.url,
                                                "blobPath" : result.blobPath,
                                            }
                                        };
                                    } else {
                                        return {
                                            "success" : 1,
                                            "file": {
                                                "url" : result.url,
                                                "blobPath" : result.blobPath,
                                            }
                                        };
                                    }
                                },
                                uploadByUrl : async(url) => {
                                    console.log('url',url)
                                }
                            },
                        } ,
                    },
                    table: {
                        class: Table,
                        inlineToolbar: true,
                        config: {
                            rows: 2,
                            cols: 3,
                        },
                    },
                    header: {
                        class: Header,
                    },
                    list: {
                        class: List,
                        inlineToolbar: true,
                        config: {
                            defaultStyle: 'unordered'
                        }
                    }
                },
                autofocus: true,
                onChange: async () => {
                    setContent(await editor.save());
                },
            });
            setEditorInstance(editor);
            return () => {
                if(editorInstance){
                    editorInstance.destroy();
                }
            };
        }
    // eslint-disable-next-line
    },[isPopup]);


   // console.log('isEditorVisible',isEditorVisible);
    return <div id='editor-container'></div>;
};


export default EditorComponent;
